const InfoCardsSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Amaca S.r.l.</h2>
          <p className="text-xl text-gray-600">
            La tua azienda di fiducia per tecnologia all'ingrosso
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center group hover:transform hover:scale-105 transition-all">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-blue-600 transition-colors">
              <i className="ri-map-pin-line text-3xl text-blue-600 group-hover:text-white transition-colors"></i>
            </div>
            <h3 className="text-xl font-semibold mb-3 text-gray-900">Sede</h3>
            <p className="text-gray-600 leading-relaxed">
              Via Don Domenico D'Angelo 31<br />
              80025 Casandrino (NA)
            </p>
          </div>
          
          <div className="text-center group hover:transform hover:scale-105 transition-all">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-green-600 transition-colors">
              <i className="ri-phone-line text-3xl text-green-600 group-hover:text-white transition-colors"></i>
            </div>
            <h3 className="text-xl font-semibold mb-3 text-gray-900">Contatti</h3>
            <p className="text-gray-600 leading-relaxed">
              <a href="tel:+393508628049" className="hover:text-green-600 cursor-pointer">
                Tel: 350 862 8049
              </a>
              <br />
              <a href="mailto:ordini.amacasrl@gmail.com" className="hover:text-green-600 cursor-pointer break-all">
                ordini.amacasrl@gmail.com
              </a>
            </p>
          </div>
          
          <div className="text-center group hover:transform hover:scale-105 transition-all">
            <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-purple-600 transition-colors">
              <i className="ri-time-line text-3xl text-purple-600 group-hover:text-white transition-colors"></i>
            </div>
            <h3 className="text-xl font-semibold mb-3 text-gray-900">Orari</h3>
            <p className="text-gray-600 leading-relaxed">
              Lun-Ven: 09:00 - 18:00<br />
              Sab-Dom: Chiuso
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoCardsSection;
